<div id="access-denied-container">
  <div class="illustration">
    <img src="../../../../../assets/images/230512_oodok_beeldmerk_4_blauw.svg" alt="Access denied illustration" />
  </div>
  <h2>Let op: je hebt geen toegang tot deze applicatie</h2>
  <p>Je hebt geen toegang tot de Stikstof Quickscan applicatie. Neem contact met ons op als dit niet correct is.</p>
  <div class="button-group">
    <a href="mailto:klop@anteagroup.nl" class="btn contact">Neem contact op</a>
    @if (portalUrl) {
      <a (click)="navigate()" class="btn portal">Terug naar portaal</a>
    }
  </div>
</div>
